import { defineMessages } from 'react-intl';

export default defineMessages({
  creditsListingCopy: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.credits-listing-copy',
    defaultMessage: 'Your classes are then listed in credit amounts to ClassPass members, which have no fixed value.',
  },
  creditsListingCopyWithLink: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.credits-listing-copy-with-link',
    defaultMessage:
      'Your classes are then listed in credit amounts to ClassPass members, which have no fixed value. <faqLink>What are ClassPass credits?</faqLink>',
  },
  payoutBarDirectPrice: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.payout-bar.direct-price',
    defaultMessage: 'Direct<br></br>price',
  },
  payoutBarPayout: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.payout-bar.payout',
    defaultMessage: 'Payout',
  },
  payoutBarRateFloor: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.payout-bar.rate-floor',
    defaultMessage: 'Rate<br></br>floor',
  },
  rateFloorCopy: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.rate-floor-copy',
    defaultMessage:
      "We've worked with you to set your confidential rate floor based on a percentage of your direct pricing.",
  },
  scheduleIllustrationDateHeader: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.schedule-illustration.date-header',
    defaultMessage: 'Thu 23',
  },
  scheduleIllustrationDuration: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.schedule-illustration.duration',
    defaultMessage: '45 min',
  },
  scheduleIllustrationRow1Time: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.schedule-illustration.row-1.time',
    defaultMessage: '07:00',
  },
  scheduleIllustrationRow2Time: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.schedule-illustration.row-2.time',
    defaultMessage: '08:00',
  },
  summaryBody: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.summary-body',
    defaultMessage:
      'This generates truly incremental revenue by turning unused spots into earnings, rather than letting them go to waste.',
  },
  summaryHeading: {
    id: 'smart-rate.how-smart-rate-works.guaranteed-minimum-panel.summary-heading',
    defaultMessage: 'Guaranteed minimum payout per qualifying reservation',
  },
});
